import React, { useState, useEffect, useRef } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import { getUserDetail } from 'actions/seller'
import moment from "moment";
import Avatar from '@mui/material/Avatar';
import { connect } from 'react-redux'
import Tooltip from '@mui/material/Tooltip';
import axios from 'constants/axios';
import { NotificationManager } from 'react-notifications';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import AppConfig from 'constants/config'
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';

const ComplianceForm = (props) => {
    let drugLic20B = useRef()
    const [expiryDate, setExpiryDate] = useState(moment().add(2, 'M'))
    const [value, setValue] = useState('')
    const [isVisited, setIsVisited] = useState(false)
    const [licNo, setLicNo] = useState('')
    const [openModal, setOpenModal] = useState(false)

    useEffect(() => {
        if (props.fileKey) {
            let user = props.userDetails.mainUser ? props.userDetails.mainUser : props.userDetails
            setValue((user[props.fileKey] && user[props.fileKey].name) ? `${AppConfig.baseUrl}users/${user[props.fileKey].name}` : '')
            setExpiryDate(user[props.fileKey] && user[props.fileKey].expires ? moment(user[props.fileKey].expires) : expiryDate)
            setLicNo(user[props.fileKey] ? user[props.fileKey].lic : licNo)
        }
    }, [props.userDetails])

    const handleFileSelect = (e) => {
        let document = "";
        let reader = new FileReader();
        if (e.target.files.length > 0) {
            reader.readAsDataURL(e.target.files[0]);
            reader.onload = () => {
                let data = {}
                document = reader.result;
                data[props.fileKey] = document
                setValue(document)
            };
            reader.onerror = function (error) {
            };
        }
    }

    const apiCall = (data) => {
        axios.post('/users/updateComplainceForm', data, {
            headers: {
                'Content-Type': 'application/json',
                'token': localStorage.getItem('token')
            },
        }
        ).then(result => {
            if (result.data.error) {
                NotificationManager.error(result.data.title);
            } else {
                NotificationManager.success('Compliance details updated successfully.');
                setOpenModal(false)
                setTimeout(() => {
                    props.getUserDetail({ userType: 'seller' })
                }, 2000);
            }
        })
            .catch(error => {
                NotificationManager.error('Something went wrong, Please try again')
            });
    }

    const handledateChange = (value) => {
        let data = {}
        data[props.name] = value
        setExpiryDate(value)
    }

    const handleChange = (e) => {
        setLicNo(e.target.value)
        setIsVisited(true)
    }

    const handleFocus = () => {
        setIsVisited(true)
    }

    const handleSubmit = () => {
        if (value && licNo) {
            let data = {}
            data[props.fileKey] = value.length > 200 ? value : '';
            data[props.name] = expiryDate;
            data[props.licKey] = licNo
            handleOpenModal('value', data)
        } else if (!licNo) {
            setIsVisited(true)
        } else if (!value) {
            NotificationManager.error('Please upload photo')
        }
    }

    const getDisabled = () => {
        let user = props.userDetails.mainUser ? props.userDetails.mainUser : props.userDetails
        let expiryDate1 = user[props.fileKey] && user[props.fileKey].expires ? user[props.fileKey].expires : expiryDate
        let imageValue1 = (user[props.fileKey] && user[props.fileKey].name) ? `${AppConfig.baseUrl}users/${user[props.fileKey].name}` : ''
        let licNo1 = user[props.fileKey] && user[props.fileKey].lic ? user[props.fileKey].lic : licNo
        if (moment(expiryDate1).isSame(moment(expiryDate)) && imageValue1 === value && licNo1 === licNo) {
            return true
        } else {
            return false
        }
    }

    const handleOpenModal = () => {
        setOpenModal(true)
    }

    const handleClose = () => {
        setOpenModal(false)
    }

    const onSave = () => {
        let data = {}
        data[props.fileKey] = value.length > 200 ? value : '';
        data[props.name] = expiryDate;
        data[props.licKey] = licNo
        apiCall(data)
    }

    const { label, name, label2, fileKey } = props
    let isMainUser = props.userDetails.mainUser ? false : true
    return (
        <React.Fragment>
            <div className='text-center'>
                <div className="p-2">
                    <input
                        type='file'
                        accept='.jpg, .png, .jpeg, .pdf'
                        style={{ display: 'none' }}
                        onChange={handleFileSelect} ref={(ref) => drugLic20B = ref}
                    />
                    <div class="img-wrap">
                    </div>
                    <img alt="file" src={value !== '' ? require('assets/images/uploaded.png') : require('assets/images/file.png')} className='d-block mx-auto' />
                </div>
                <label className="text-dark" style={{ fontSize: 17 }}>{label}</label>
            </div>
            {
                name &&
                <div className="pt-2 text-center">
                    <span>Expiry date : </span>
                    <LocalizationProvider dateAdapter={AdapterMoment}>
                        <MobileDatePicker
                            onChange={handledateChange}
                            name={name}
                            value={expiryDate}
                            minDate={moment()}
                            id="datePickerStyle"
                            className={'datePickerStyle cursor-pointer'}
                            leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                            rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                            format="MM/DD/YYYY"
                        />
                    </LocalizationProvider>
                </div>
            }
            <div className="pt-2 text-center">
                <p>{label2}</p>
                <TextField
                    error={(isVisited && !licNo && fileKey !== "gstLic") || (isVisited && fileKey === "gstLic" && licNo && licNo.length <= 15 && !/\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/.test(licNo))}
                    id="outlined-error-helper-text"
                    label={''}
                    className={'cursor-pointer liCNo'}
                    helperText={isVisited && !licNo && fileKey !== "gstLic" ? "This field is required" : isVisited && fileKey === "gstLic" && licNo && licNo.length <= 15 && !/\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}/.test(licNo) ? 'Invalid GST' : ""}
                    margin="normal"
                    variant="standard"
                    value={licNo}
                    onClick={handleFocus}
                    onChange={handleChange}
                />
            </div>

            <div className='d-flex mx-md-n5 text-center justify-content-center d-flex pt-2'>
                <div className='mr-1 ml-1'>
                    <Tooltip title={` ${label}`}>
                        <Avatar className='bg-primary cursor-pointer' onClick={(e) => drugLic20B.click()} size={2}>
                            <i className='zmdi zmdi-upload'></i>
                        </Avatar>
                    </Tooltip>
                </div>
                <div className='mr-1 ml-1'>
                    <Tooltip title={`${value ? 'View ' + label : label + ' not uploaded'} `} >
                        <Avatar className='bg-warning' color='primary' size={2}>
                            <a rel="noreferrer" href={value} style={value ? { padding: 0 } : { pointerEvents: 'none', cursor: 'default' }} disabled={value ? false : true} target='_blank'><i className='zmdi zmdi-eye text-white'></i></a>
                        </Avatar>
                    </Tooltip>
                </div>
                {
                    !getDisabled() && isMainUser &&
                    <div className='mr-1 ml-1'>
                        <Tooltip title={`Save ${label}`}>
                            <Avatar className={`bg-success cursor-pointer `} onClick={(e) => handleSubmit()} size={2}>
                                <i className='zmdi zmdi-floppy'></i>
                            </Avatar>
                        </Tooltip>
                    </div>
                }
            </div >
            <Dialog open={openModal === true}
                onClose={handleClose}
                fullWidth={true}
            >
                <DialogTitle id="alert-dialog-title" ><h2 style={{ color: "#fd4081" }}>Important Message</h2></DialogTitle>
                <DialogContent>
                    <h3>If you save, your profile will have to go under verification process again.</h3>
                </DialogContent>
                <DialogActions className="pr-4">
                    <Button onClick={onSave} color='primary'> SAVE </Button>
                    <Button onClick={handleClose} color='secondary' >	Cancel </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment >
    );
}

const mapStateToProps = ({ seller }) => {
    const { userDetails } = seller;
    return { userDetails }
}
export default connect(mapStateToProps, { getUserDetail })(ComplianceForm);